import { Routes, Route, Navigate } from "react-router";
import { LoginPage } from "@/features/auth/login";
import { NotFoundPage } from "@/features/not-found";
import { SubscriptionConfirmationPage } from "@/features/subscriptions/confirm";
import { TrialEndPage } from "@/features/subscriptions/trial-end";
import { ProtectedRoute } from "@/components/protected-route";
import { AuthenticatedRoute } from "@/components/authenticated-route";
import { Sidebar } from "@/features/dash/sidebar";
import { OverviewPage, Registrations, ContactsPage, AnimateursPage, ComptabilitePage, ClubInfoPage } from "@/features/dash";
import { ForgetPasswordPage } from "@/features/auth/forget-password";
import { ResetPasswordPage } from "@/features/auth/reset-password";
import AuthLayout from "@/layouts/auth-layout";
import { OnboardingStep1 } from "@/features/onboarding/step1";
import { OnboardingStep2 } from "@/features/onboarding/step2";
import { OnboardingStep3 } from "@/features/onboarding/step3";
import { OnboardingStep4 } from "@/features/onboarding/step4";
import { OnboardingStep6 } from "@/features/onboarding/step6";
import { OnboardingStep7 } from "@/features/onboarding/step7";
import { OnboardingStep8 } from "@/features/onboarding/step8";
import { NewRegistration } from "@/features/dash/registrations/pages/new";
import { RegistrationDetails } from "@/features/dash/registrations/pages/details";
import { EditRegistration } from "@/features/dash/registrations/pages/edit";
import { RegistrationLayout } from "@/features/dash/registrations/layout";
import { AcceptInvitationPage } from "@/features/invitations/accept-invitation-page";

function App() {
  return (
    <Routes>
      {/* Auth Layout Routes */}
      <Route element={<AuthLayout />}>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forget-password" element={<ForgetPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/onboarding">
          <Route index element={<OnboardingStep1 />} />
          <Route path="step1" element={<OnboardingStep1 />} />
          <Route
            path="step2"
            element={
              <ProtectedRoute allowUnsubscribed={true}>
                <OnboardingStep2 />
              </ProtectedRoute>
            }
          />
          <Route
            path="step3"
            element={
              <ProtectedRoute allowUnsubscribed={true}>
                <OnboardingStep3 />
              </ProtectedRoute>
            }
          />
          <Route
            path="step4"
            element={
              <ProtectedRoute allowUnsubscribed={true}>
                <OnboardingStep4 />
              </ProtectedRoute>
            }
          />
          <Route
            path="step6"
            element={
              <ProtectedRoute allowUnsubscribed={true}>
                <OnboardingStep6 />
              </ProtectedRoute>
            }
          />
          <Route
            path="step7"
            element={
              <ProtectedRoute allowUnsubscribed={true}>
                <OnboardingStep7 />
              </ProtectedRoute>
            }
          />
          <Route
            path="step8"
            element={
              <ProtectedRoute allowUnsubscribed={true}>
                <OnboardingStep8 />
              </ProtectedRoute>
            }
          />
          <Route path="done" element={<Navigate to="/dash" replace />} />
          <Route path="*" element={<Navigate to="/onboarding" replace />} />
        </Route>
      </Route>

      {/* Protected Subscription Routes */}
      <Route path="/subscriptions" element={<AuthenticatedRoute />}>
        <Route path="trial-end" element={<TrialEndPage />} />
        <Route path="confirm" element={<SubscriptionConfirmationPage />} />
      </Route>

      {/* Accept Invitation Route (public) */}
      <Route path="/accept-invitation/:id" element={<AcceptInvitationPage />} />

      {/* Protected Dashboard Routes */}
      <Route
        path="/dash/*"
        element={
          <ProtectedRoute>
            <Sidebar />
          </ProtectedRoute>
        }
      >
        <Route index element={<OverviewPage />} />

        {/* Registration routes with shared layout for breadcrumb animation */}
        <Route path="registrations" element={<RegistrationLayout />}>
          <Route index element={<Registrations />} />
          <Route path="new" element={<NewRegistration />} />
          <Route path=":id" element={<RegistrationDetails />} />
          <Route path=":id/edit" element={<EditRegistration />} />
        </Route>
        <Route path="contacts" element={<ContactsPage />} />
        <Route path="animateurs" element={<AnimateursPage />} />
        <Route path="comptabilite" element={<ComptabilitePage />} />
        <Route path="settings" element={<ClubInfoPage />} />
      </Route>

      {/* Legacy dashboard route - redirect to new structure */}
      <Route path="/dashboard" element={<Navigate to="/dash" replace />} />

      {/* Redirects */}
      <Route path="/" element={<Navigate to="/dash" replace />} />

      {/* 404 */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export default App;
